// src/AuthForm.js
import React, { useState } from "react";
import axios from "axios";
// ya no usamos AuthForm.css para el layout principal
import "./AuthForm.css";

const API_URL = process.env.REACT_APP_API_URL;

export default function AuthForm({ onAuthenticated, onBack }) {
  const [fase, setFase]     = useState("login");    // "login" | "register" | "verify"
  const [email, setEmail]   = useState("");
  const [password, setPass] = useState("");
  const [code, setCode]     = useState("");
  const [msg, setMsg]       = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg("");
    try {
      if (fase === "login") {
        const { data } = await axios.post(`${API_URL}/login`, { email, password });
        localStorage.setItem("token", data.access_token);
        localStorage.setItem("email", email);
        axios.defaults.headers.common["Authorization"] = `Bearer ${data.access_token}`;
        onAuthenticated(email);
      } else {
        await axios.post(`${API_URL}/register`, { email, password });
        setFase("verify");
      }
    } catch (err) {
      setMsg(err.response?.data?.detail || "Ocurrió un error");
    }
  };

  const handleVerify = async () => {
    setMsg("");
    try {
      const { data } = await axios.post(`${API_URL}/verify-code`, { email, code });
      localStorage.setItem("token", data.access_token);
      localStorage.setItem("email", email);
      axios.defaults.headers.common["Authorization"] = `Bearer ${data.access_token}`;
      onAuthenticated(email);
    } catch (err) {
      setMsg(err.response?.data?.detail || "Código inválido");
    }
  };

  // ——— LOGIN / REGISTER ———
  if (fase === "login" || fase === "register") {
    return (
      <div className="container formulario-container">
        <div className="formulario-content">
          <button onClick={onBack} className="boton-nav" style={{ marginBottom: "20px" }}>
            ← Volver al inicio
          </button>
          <h1 style={{ marginBottom: "1rem", color: "#2c3e50" }}>
            {fase === "login" ? "Iniciar sesión" : "Regístrate"}
          </h1>

          {/* pestañas */}
          <div className="auth-toggle" style={{ marginBottom: "1.5rem" }}>
            <button
              className={fase==="login"?"active":""}
              onClick={()=>setFase("login")}
            >Iniciar sesión</button>
            <button
              className={fase==="register"?"active":""}
              onClick={()=>setFase("register")}
            >Registrarse</button>
          </div>

          <form className="formulario-registro" onSubmit={handleSubmit}>
            <div className="campo-formulario">
              <label>Tu correo</label>
              <input
                type="email"
                placeholder="tu@correo.com"
                value={email}
                onChange={e=>setEmail(e.target.value)}
                required
              />
            </div>
            <div className="campo-formulario">
              <label>Tu contraseña</label>
              <input
                type="password"
                placeholder="Mín. 6 caracteres"
                value={password}
                onChange={e=>setPass(e.target.value)}
                required
                minLength={6}
              />
            </div>
            <button type="submit" className="boton-ver-resultados">
              {fase==="login"?"Iniciar sesión":"Crear cuenta"}
            </button>
          </form>

          {msg && <p className="auth-error">{msg}</p>}
        </div>
      </div>
    );
  }

  // ——— VERIFICACIÓN DE CÓDIGO ———
  if (fase === "verify") {
    return (
      <div className="container formulario-container">
        <div className="formulario-content">
          <button onClick={() => setFase("register")} className="boton-nav" style={{ marginBottom: "20px" }}>
            ← Volver al inicio
          </button>
          <h1 style={{ marginBottom: "1rem", color: "#2c3e50" }}>Verifica tu correo</h1>
          <p style={{ marginBottom: "1.5rem" }}>
            Hemos enviado un código de 6 dígitos a:<br/>
            <strong>{email}</strong>
          </p>
          <div className="campo-formulario">
            <label>Código de verificación</label>
            <input
              type="text"
              placeholder="123456"
              value={code}
              onChange={e=>setCode(e.target.value)}
              maxLength={6}
            />
          </div>
          <button
            onClick={handleVerify}
            className="boton-ver-resultados"
            disabled={code.length !== 6}
          >
            Verificar código
          </button>
          {msg && <p className="auth-error">{msg}</p>}
        </div>
      </div>
    );
  }

  return null;
}
